// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"672":"7ca41e9c90807c71e084","849":"dd290b25403eac85adc3"}[chunkId] + ".chunk.js";
};